<template>
  <div
    :class="divClasses"
    :style="boxStyle"
    @mousedown="startDrag"
  >
    {{ local.text }}
  </div>
</template>

<script>
export default {
  /* ------------------------------------------------------------------ */
  props: {
    text      : { type: Object,  required: true },   // { left, top, width, height… } in PDF pts
    textIndex : { type: Number,  required: true },
    /* tell the component how big one PDF “unit” is --------------------- */
    pdfWidth  : { type: Number,  default: 595 },     // pts
    pdfHeight : { type: Number,  default: 420 }      // pts
  },

  data () {
    return {
      isDragging  : false,
      dragOffsetX : 0,
      dragOffsetY : 0,
      local       : { ...this.text }
    };
  },

  /* ----- current zoom factor (CSS‑px per PDF‑pt) --------------------- */
  computed: {
    scaleX () {
      const p = this.$el?.parentElement;
      return p ? p.clientWidth  / this.pdfWidth  : 1;
    },
    scaleY () {
      const p = this.$el?.parentElement;
      return p ? p.clientHeight / this.pdfHeight : 1;
    },

    /* style the box in **CSS pixels** --------------------------------- */
    boxStyle () {
      return {
        position: 'absolute',
        left : this.local.left   * this.scaleX + 'px',
        top  : this.local.top    * this.scaleY + 'px',
        width: this.local.width  * this.scaleX + 'px',
        height: this.local.height * this.scaleY + 'px',

        color    : this.local.color,
        fontSize : this.local.size * this.scaleY + 'px',
        textAlign: this.local.align,
        cursor   : this.isDragging ? 'grabbing' : 'grab',

        display       : 'flex',
        alignItems    : 'center',
        justifyContent: 'center'
      };
    },

    divClasses () {
      return [
        'draggable-text',
        this.local.font === 'cormorant.ttf' ? 'cormorant-font' : 'tangerine-font'
      ];
    }
  },

  watch: {
    text: { deep: true, immediate: true, handler (v) { this.local = { ...v }; } }
  },

  /* ------------------------------------------------------------------ */
  methods: {
    startDrag (e) {
      if (e.button !== 0) return;
      e.preventDefault();
      
      this.isDragging  = true;

      const r          = this.$el.getBoundingClientRect();
      this.dragOffsetX = e.clientX - r.left;   // px inside the box
      this.dragOffsetY = e.clientY - r.top;

      window.addEventListener('mousemove', this.dragMove);
      window.addEventListener('mouseup',   this.endDrag);
    },

    dragMove (e) {
      if (!this.isDragging) return;

      const parentRect = this.$el.parentElement.getBoundingClientRect();

      /* ---- pointer’s position in CSS px -------------------------------- */
      const cssLeft = e.clientX - parentRect.left - this.dragOffsetX;
      const cssTop  = e.clientY - parentRect.top  - this.dragOffsetY;

      /* ---- convert back to PDF pts before storing ---------------------- */
      this.local.left = cssLeft / this.scaleX;
      this.local.top  = cssTop  / this.scaleY;

      this.$emit('update-position', this.textIndex, this.local.left, this.local.top);
    },

    endDrag () {
      this.isDragging = false;
      window.removeEventListener('mousemove', this.dragMove);
      window.removeEventListener('mouseup',   this.endDrag);
    }
  }
};
</script>

<style scoped>
@font-face { font-family: 'tangerine'; src: url('~@/assets/fonts/tangerine.ttf') format('truetype'); }
@font-face { font-family: 'cormorant'; src: url('~@/assets/fonts/cormorant.ttf') format('truetype'); }

.tangerine-font { font-family: 'tangerine'; }
.cormorant-font { font-family: 'cormorant'; }

.draggable-text{
  outline:1px dashed rgba(0,0,0,.5); 
  outline-offset:2px; 
  padding:2px;

  /* NEW — prevent blue highlight */
  user-select: none;          /* modern browsers */
  -webkit-user-select: none;  /* Safari / early Chrome */
  -moz-user-select: none;     /* Firefox */
  -ms-user-select: none;      /* old Edge */
}

</style>
